export const UpgradeIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='20.72'
			height='29.41'
			className='upgrade-icon-svg'
			viewBox='0 0 18.139 25.743'>
			<g id='flying-rocket' transform='translate(-63.093)'>
				<g id='Group_4669' data-name='Group 4669' transform='translate(63.093)'>
					<path
						id='Path_3473'
						data-name='Path 3473'
						d='M65.551,133.209c-.023-.347.073-1.415-.3-1.069a19.675,19.675,0,0,0-1.742,1.907,1.538,1.538,0,0,0-.417.97v8.045c0,.316.188.4.417.179l3.382-3.534c.22-.222.04-.442-.03-.582A16.751,16.751,0,0,1,65.551,133.209Z'
						transform='translate(-63.093 -121.883)'
						fill='#fff'
					/>
					<path
						id='Path_3474'
						data-name='Path 3474'
						d='M251.1,134.047a19.663,19.663,0,0,0-1.742-1.907c-.372-.346-.276.722-.3,1.069a16.753,16.753,0,0,1-1.31,5.917c-.069.14-.25.36-.03.582l3.382,3.534c.229.218.417.137.417-.179v-8.045A1.536,1.536,0,0,0,251.1,134.047Z'
						transform='translate(-233.372 -121.882)'
						fill='#fff'
					/>
					<path
						id='Path_3475'
						data-name='Path 3475'
						d='M110.994,18.268c3.393,0,4.217-.8,4.217-.8.983-1.651,1.587-4.8,1.587-8.16C116.8,4.219,112.326,0,110.982,0s-5.816,4.219-5.816,9.309c0,3.257.6,6.509,1.587,8.16C106.753,17.469,107.527,18.268,110.994,18.268ZM110.92,6.76a2.964,2.964,0,1,1-2.963,2.964A2.964,2.964,0,0,1,110.92,6.76Z'
						transform='translate(-101.92)'
						fill='#fff'
					/>
					<path
						id='Path_3476'
						data-name='Path 3476'
						d='M125.826,238.937c-.079-.3-.123.279-2.3.282s-2.222-.587-2.3-.282c-.015.06-.089.711-.112.946a10.373,10.373,0,0,0-.091,1.065c0,.922.518,1.687.771,1.687.27,0,.526-.677.526-.677.032-.052.077-.049.1.008,0,0,.591,2.067,1.088,2.067l.019,0,.019,0c.5,0,1.088-2.067,1.088-2.067.023-.057.069-.061.1-.008,0,0,.256.677.526.677.253,0,.771-.764.771-1.687a10.382,10.382,0,0,0-.091-1.065C125.916,239.647,125.842,239,125.826,238.937Z'
						transform='translate(-114.492 -218.29)'
						fill='#fff'
					/>
				</g>
			</g>
		</svg>
	)
}
